import { Bath, Building, Gavel, Home, KeyRound, Plug } from 'lucide-react'

export type Service = {
  title: string
  description: string
  imageUrl: string
  icon: React.ElementType
  alt: string
}

export const services: Service[] = [
  {
    title: 'Plombier',
    alt: 'Plombier effectuant une réparation de canalisation',
    description:
      'Installation, dépannage et rénovation de plomberie. Intervention rapide et travail soigné pour particuliers et professionnels dans les Yvelines.',
    imageUrl: '/images/services/plomberie.webp',
    icon: Bath,
  },
  {
    title: 'Serrurier',
    alt: 'Serrurier ouvrant une porte avec ses outils',
    description:
      'Ouverture de porte, changement de serrure et renforcement de sécurité. Serrurier disponible 7j/7 pour un service rapide et fiable.',
    imageUrl: '/images/services/serrurerie.webp',
    icon: KeyRound,
  },
  {
    title: 'Vitrier',
    alt: 'Vitrier installant une vitre double vitrage',
    description:
      'Remplacement et pose de vitrages sur mesure. Intervention rapide pour vos fenêtres, vitrines et baies vitrées.',
    imageUrl: '/images/services/vitrerie.webp',
    icon: Building,
  },
  {
    title: 'Électricien',
    alt: 'Électricien installant un tableau électrique moderne',
    description:
      'Installation, rénovation et dépannage électriques. Mise aux normes et solutions domotiques pour plus de confort et de sécurité.',
    imageUrl: '/images/services/electricite.webp',
    icon: Plug,
  },
  {
    title: 'Menuisier',
    alt: 'Menuisier découpant une planche en bois sur mesure',
    description:
      'Conception et pose de menuiseries sur mesure. Fenêtres, portes et meubles réalisés avec soin et matériaux durables.',
    imageUrl: '/images/services/menuiserie.webp',
    icon: Gavel,
  },
  {
    title: 'Couvreur',
    alt: 'Couvreur zingueur travaillant sur une toiture en tuiles',
    description:
      "Rénovation et réparation de toiture. tuiles/ardoises, zinguerie, étanchéité, démoussage, recherche d'infiltrations, isolation des combles et pose de fenêtres de toit.",
    imageUrl: '/images/services/couvreur.webp',
    icon: Home,
  },
]
